import { Tooltip } from "@whatslly/ui-components/Tooltip";
import { Svg } from "@whatslly/ui-components/v2/BaseElements/Svg";
import React from "react";

export const MessageSynced: React.FC = () => {
  return (
    <div className="tuvisMessageSynced">
      <Svg iconName="v-icon" width={6} />
    </div>
  );
};

export const MessageSyncInvalid: React.FC<{ reason: string }> = ({ reason }) => {
  return (
    <div className="tuvisMessageSyncInvalid">
      <Tooltip value={reason}>
        <Svg iconName="unknown-issue" width={12} />
      </Tooltip>
    </div>
  );
};
